import { render, staticRenderFns } from "./ProposalWizard.vue?vue&type=template&id=3b5ada04&scoped=true&"
import script from "./ProposalWizard.vue?vue&type=script&lang=js&"
export * from "./ProposalWizard.vue?vue&type=script&lang=js&"
import style0 from "./ProposalWizard.vue?vue&type=style&index=0&id=3b5ada04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5ada04",
  null
  
)

export default component.exports